import Image from 'next/image';
import {useRouter} from 'next/router';
import React, {useEffect, useState} from 'react';

import Box from '../Box';
import ResponseMessage from '../ResponseMessage';
import Typography from '../Typography';
import styles from './NoResults.module.scss';
import NoResults1 from './images/noResults1.png';
import NoResults2 from './images/noResults2.png';
import NoResults3 from './images/noResults3.png';
import NoResults1en from './images/noResults1en.png';
import NoResults2en from './images/noResults2en.png';
const images = {
  de: {
    images: [NoResults1, NoResults2, NoResults3],
  },
  en: {images: [NoResults1en, NoResults2en, NoResults3]},
};
const NoResults = ({
  reponseMessage,
  style,
}: {
  reponseMessage: string;
  style?: React.CSSProperties;
}) => {
  const {locale} = useRouter();
  
  const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);

  const selectRandomImage = locale => {
    const randomIndex = Math.floor(Math.random() * images?.[locale].images.length);
    setSelectedImageIndex(randomIndex);
  };

  useEffect(() => {
    selectRandomImage(locale);
  }, []);

  return (
    <Box>
      <Image
        src={images?.[locale]?.images?.[selectedImageIndex]}
        height={images?.[locale]?.images?.[selectedImageIndex]?.height}
        width={images?.[locale]?.images?.[selectedImageIndex]?.width}
        alt=""
        style={style}
        className={styles.image}
      />
      <ResponseMessage sx={{marginTop: '20px'}} variant="info">
        <Typography sx={{lineHeight: '24px'}}>
          <b>{reponseMessage}</b>
        </Typography>
      </ResponseMessage>
    </Box>
  );
};

export default NoResults;
